/**
 * Utility functions for table formatting and data processing
 */

/**
 * Capitalizes the first letter of a word
 */
export const capitalizeWord = (word: string): string => {
  if (!word) return word;
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};

/**
 * Formats a date string to a readable format
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return '';

  const date = new Date(dateString);
  return `${date.toLocaleDateString('en-uk', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
  })} at ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
};

/**
 * Truncates text to a specified number of words
 */
export const truncateText = (text: string, maxWords: number = 15): string => {
  if (!text) return '';

  const words = text.split(' ');
  if (words.length <= maxWords) {
    return text;
  }

  return words.slice(0, maxWords).join(' ') + ' ...';
};

/**
 * Extracts properties from carbon project data structure
 */
export const extractCarbonProjectProperties = (project: any) => {
  return project?.properties || project;
};

/**
 * Determines the navigation path for a project
 */
export const getProjectNavigationPath = (
  project: any,
  projectType: 'recommendation' | 'current' | 'saved',
  recommendationType?: string,
): string => {
  switch (projectType) {
    case 'recommendation':
      return recommendationType === 'Forests'
        ? `/recommendation/forest/${project.id}`
        : `/recommendation/mangrove/${project.id}`;

    case 'current': {
      const carbonProject = extractCarbonProjectProperties(project);
      return `/project/${carbonProject.id}`;
    }

    case 'saved':
      return `/${
        project.project_type === 'mangrove_recommendation' ? 'recommendation' : 'project'
      }/${project.id}`;

    default:
      return '/';
  }
};
